// extracted by mini-css-extract-plugin
export default {"item":"NoOptionsWithCustomFooter_item__yiyDr"};